module.exports = __webpack_public_path__ + "static/media/bg_stu_gray.1771577a.png";